import { tireBrandsParamName } from "./TireBrandFilters/useTireBrands";
import { tireLoadRatingParamName } from "./TireLoadRaitingFilters/useTireLoadRating";
import { useTirePLYRatingParamName } from "./TirePlyRaitingFilters/useTirePLYRating";
import { useTirePricingParamName } from "./TirePriceFilters/useTirePricing";
import { useSpeedIndexParamName } from "./TireSpeedIndexFilters/useSpeedIndex";

export const secondaryTireFilters = [
  tireBrandsParamName,
  tireLoadRatingParamName,
  useTirePLYRatingParamName,
  useTirePricingParamName,
  useSpeedIndexParamName,
];
